import React from 'react';
import { Grid } from '@mui/material';
import Input from 'components/Input';

const Filter = ({ grid, control }) => {
  const checkDisplay = (name) => {
    const column = grid?.colunas?.find((c) => c?.field === name);
    if (column?.filterable) {
      return true;
    }
    return false;
  };

  return (
    <Grid container spacing={2}>
      {checkDisplay('id') && (
        <Grid item xs={12}>
          <Input name="id" control={control} label="ID" type="number" />
        </Grid>
      )}
      {checkDisplay('nome') && (
        <Grid item xs={12}>
          <Input name="nome" control={control} label="Nome" />
        </Grid>
      )}
      {checkDisplay('sigla') && (
        <Grid item xs={12}>
          <Input name="sigla" control={control} label="Sigla" />
        </Grid>
      )}
      {checkDisplay('codigo') && (
        <Grid item xs={12}>
          <Input name="codigo" control={control} label="Código" type="number" />
        </Grid>
      )}
    </Grid>
  );
};

export default Filter;
